import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { IssueService } from '../../../../services/issue.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';


@Component({
    selector: 'issues-summary-grid-item',
    templateUrl: './issues-summary-grid-item.component.html'
})
export class IssuesSummaryGridItemComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    numberOfConsumerWithIssues: number;
    numberOfIssues: number;
    paygIssuesLastMonth: number;
    issuesVariation: number;
    subscriptions: any[] = [];

    isDecreasing: boolean = false;
    isIncreasing: boolean = false;


    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.issueService.paygSummary(this.clientId).then((result) => {
            let res = result as any;
            this.numberOfConsumerWithIssues = res.numberofConsumersExperiencingIssues != null ? res.numberofConsumersExperiencingIssues : 0;
            this.numberOfIssues = res.numberOfIssues != null ? res.numberOfIssues : 0;
            this.paygIssuesLastMonth = res.paygIssuesLastMonth != null ? res.paygIssuesLastMonth : 0;

            this.isIncreasing = this.paygIssuesLastMonth < this.numberOfIssues ? true : false;
            this.isDecreasing = this.paygIssuesLastMonth > this.numberOfIssues ? true : false;

            this.issuesVariation = this.numberOfIssues - this.paygIssuesLastMonth;
        }).catch(reason => {
            this.numberOfConsumerWithIssues = 0;
            this.numberOfIssues = 0;
            this.issuesVariation = 0;
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
